
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remoteworktown",
      function () {
        return require("private-next-pages/remoteworktown/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/remoteworktown"])
      });
    }
  